import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "RemindersModule"
const debug = false

export class RemindersModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.REMINDERS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Reminders"
        this.description                = "The Reminders module is a versatile tool that allows users to create personal reminders for various events or tasks. This feature enables users to set up reminders for important deadlines, meetings, appointments, or any other personal tasks. With customizable options and flexible scheduling, users can stay organized and on track with their daily activities."
        this.svgIcon                    = "isvg-one-2-one"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/reminders"
        this.parentSection              = SettingsParentSection.PRODUCTIVITY

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}